import { ACCOUNTS_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

async function CreateSetPasswordTokenAndSendEmail(email) {
	const url = `/${ACCOUNTS_PREFIX}/createSetPasswordTokenAndSendEmail/${email}`;
	return postApi(url, { email });
}

export default CreateSetPasswordTokenAndSendEmail;
